// extracted by mini-css-extract-plugin
export default {"container":"ModalAddBlock_container__GBA80","contentContainer":"ModalAddBlock_contentContainer__I+q4r","buttonContainer":"ModalAddBlock_buttonContainer__+KmhX"};